import { render, staticRenderFns } from "./TheMenuPrincipal.vue?vue&type=template&id=0d03217f&"
import script from "./TheMenuPrincipal.vue?vue&type=script&lang=js&"
export * from "./TheMenuPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuPrincipal.vue?vue&type=style&index=0&id=0d03217f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports